module.exports = __webpack_public_path__ + "img/219.clean_surface.5ed7541e.svg";